module.exports = __webpack_public_path__ + "assets/img/1.a0a52be5.png";